import { flatten } from 'lodash'

import { merge } from './helpers'

import * as actions from './actions'

const getRoot = state => state.__KNOWLEDGEBASE.knowledgebase

export const getArticle = state => getRoot(state).article
export const getDocument = state => getArticle(state).document
export const getTitle = state => getArticle(state).title
export const getStatus = state => getArticle(state).status
export const getDescription = state => getArticle(state).description
export const getVersion = state => getArticle(state).version
export const getSlug = state => getArticle(state).slug
export const getArticleSavingStatus = state => getArticle(state).isSaving
export const getArticleErrors = state => getArticle(state).errors

export const getArticleCategoryById = (state, id) => getCategories(state).find(category => category.id === id)
export const getArticleSectionById = (state, id) => {
  if (!id) {
    return false
  }
  
  return flatten(getCategories(state).map(category => category.sections)).find(section => section.id === id)
}

export const getCategory = state => getRoot(state).category

export const getCategories = state => getRoot(state).categories

export const getSection = (state, props) => {
  return props.sectionId ? flatten(getCategories(state).map(category => category.sections)).find(section => section.id === props.sectionId) : null
}

export const getSectionToEdit = state => getRoot(state).sectionToEdit
export const getSelectedCategoryId = state => getSectionToEdit(state).categoryId
export const getSectionToDelete = state => getRoot(state).sectionToDelete

export const getArticleCategoryId = state => getArticle(state).categoryId

export const getCategoryById = (state, props) => {
  return props.categoryId ? getCategories(state).find(category => category.id === props.categoryId) : null
}

export const getUncategorizedDocuments = (state, props) => {
  const category = getCategoryById(state, props)
  return category ? category.documents.filter(document => !document.sectionId) : []
}

export const getCategorizedDocuments = (state, props) => {
  const section = getSection(state, props)
  return section ? section.documents : null
}

export const getArticleChanged = state => getRoot(state).articleChanged
export const getIsArticleSaved = state => getArticle(state).isSaved

const getFetchArticleStatus = state => getRoot(state).fetchArticleStatus
export const getFetchArticleLoaded = state => getFetchArticleStatus(state) === actions.fetchArticleSuccess.toString()

const getFetchCategoriesStatus = state => getRoot(state).fetchCategoriesStatus
export const getFetchCategoriesLoaded = state => getFetchCategoriesStatus(state) === actions.fetchCategoriesSuccess.toString()

export const getDropdownOptions = state => merge(getCategories(state))
export const getbackEndCopyOfArticleStatus = state => getArticle(state).backEndCopyOfArticleStatus

export const getArticleIDsByPage = (state, props) => {
  const uncategorizedDocuments = getUncategorizedDocuments(state, props)
  const categorizedDocuments = getCategorizedDocuments(state, props)
  const uncategorizedDocumentsIds = uncategorizedDocuments.map(({ id }) => id)
  const sectionDocumentsIds = categorizedDocuments ? categorizedDocuments.map(({ id }) => id) : []

  return [...uncategorizedDocumentsIds, ...sectionDocumentsIds]
}